interface Args {
  date: string
  language: string
}

const formatDate = ({ date, language }: Args): string => {
  const dateObject = new Date(date)
  const formattedDate = new Intl.DateTimeFormat(language).format(dateObject)
  return formattedDate
}

export default formatDate
